/** Runner tools the agent uses for its own housekeeping, never shown to the user. */
export const INTERNAL_TOOLS: ReadonlySet<string> = new Set([
  'get_workspace_file_url', // workspace URL resolution
  'upload_cam_file', // CAM file upload
  '__refresh_dir_cache__', // rclone directory cache refresh (meta tool)
  '_validate_output_files', // post-turn output file validation (meta tool)
  '_send_refresh_dir_cache', // meta tool that triggers __refresh_dir_cache__ on the runner
  'read_scratchpad', // hidden from UI (backend suppresses SSE; filter DB rows on refresh)
  'write_scratchpad', // hidden from UI (backend suppresses SSE; filter DB rows on refresh)
]);

/** A `tool_approval_request` event: a tool waiting for the user before it runs on their machine. */
export interface ToolApprovalRequest {
  readonly tool: string;
  readonly toolUseId?: string;
  /** Serialized args JSON, shown so the user knows what they approve. */
  readonly approvalArgs?: string;
  readonly summary?: string;
  readonly agentName?: string;
}

const text = (value: unknown): string | undefined => (typeof value === 'string' ? value : undefined);

export const parseToolApprovalRequest = (data: Record<string, unknown>): ToolApprovalRequest | null => {
  const tool = text(data.tool);
  if (!tool || INTERNAL_TOOLS.has(tool)) return null;
  return {
    tool,
    toolUseId: text(data.toolUseId),
    approvalArgs: text(data.args),
    summary: text(data.summary),
    agentName: text(data.agentName),
  };
};
